var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3766 8.01379H14.623C10.9711 8.01379 8 10.985 8 14.6369V25.3906C8 29.0426 10.9711 32.0137 14.623 32.0137H25.3766C29.0288 32.0137 31.9999 29.0424 31.9999 25.3906V14.6369C32 10.985 29.0288 8.01379 25.3766 8.01379ZM29.8706 25.3906C29.8706 27.8685 27.8547 29.8843 25.3768 29.8843H14.623C12.1452 29.8844 10.1294 27.8685 10.1294 25.3906V14.6369C10.1294 12.1591 12.1452 10.1432 14.623 10.1432H25.3766C27.8545 10.1432 29.8705 12.1591 29.8705 14.6369V25.3906H29.8706Z",
    fill: "#6C5CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 13.8299C16.5901 13.8299 13.8159 16.6041 13.8159 20.0141C13.8159 23.4239 16.5901 26.1979 20.0001 26.1979C23.4101 26.1979 26.1842 23.4239 26.1842 20.0141C26.1842 16.6041 23.4101 13.8299 20.0001 13.8299ZM20.0001 24.0684C17.7644 24.0684 15.9453 22.2496 15.9453 20.0139C15.9453 17.7781 17.7642 15.9591 20.0001 15.9591C22.2359 15.9591 24.0548 17.7781 24.0548 20.0139C24.0548 22.2496 22.2358 24.0684 20.0001 24.0684Z",
    fill: "#6C5CE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4434 12.0243C26.0331 12.0243 25.6301 12.1904 25.3404 12.4814C25.0492 12.771 24.8818 13.1742 24.8818 13.5858C24.8818 13.9962 25.0493 14.3993 25.3404 14.6903C25.63 14.9799 26.0331 15.1474 26.4434 15.1474C26.8551 15.1474 27.2568 14.9799 27.5478 14.6903C27.8388 14.3993 28.0049 13.9961 28.0049 13.5858C28.0049 13.1742 27.8388 12.771 27.5478 12.4814C27.2582 12.1904 26.8551 12.0243 26.4434 12.0243Z",
    fill: "#6C5CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.24920a6c7d589bd2ed47c963deacde49.svg";
export { ForwardRef as ReactComponent };